export default [
    { key: 'index', label: 'ID' },
    { key: 'created_at', label: 'Fecha' },
    // { key: 'longitude', label: 'Longitud' },
    // { key: 'latitude', label: 'Latitud' },
    { key: 'notes', label: 'Notas' },
    { key: 'photo_url', label: 'Foto' },
    { key: 'actions', label: '' },
]